// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1D1Bn","info":"PatientInfo_info__3zGIs"};